<template>
	<md-snackbar :md-position="position" :md-duration="duration" :md-active.sync="isActive" md-persistent>
		<span>{{ title }}</span>
		<md-button v-if="btnTitle" class="button text-btn" @click="handleSnackbarButton">
			{{ btnTitle }}
		</md-button>
	</md-snackbar>
</template>

<script>
export default {
	name: 'Snackbar',
	props: {
		position: {
			type: String,
			default: 'left',
		},
	},
	data() {
		return {
			isActive: false,
			title: null,
			btnTitle: null,
			isInfinity: null,
			duration: null,
		};
	},
	created() {
		this.$bus.$on(this.$bus.CREATE_SNACKBAR, this.createSnackbarListener);
		this.$bus.$on(this.$bus.CLEAR_SNACKBAR, this.clearSnackbarListener);

		this.$once('hook:beforeDestroy', () => {
			this.$bus.$off(this.$bus.CREATE_SNACKBAR, this.createSnackbarListener);
			this.$bus.$off(this.$bus.CLEAR_SNACKBAR, this.clearSnackbarListener);
		});
	},
	methods: {
		createSnackbarListener(snackbar) {
			this.isActive = true;
			this.$emit('snackbar-active', this.isActive);
			this.title = snackbar.title;
			this.btnTitle = snackbar.btn;
			this.duration = snackbar.duration || Infinity;
		},
		handleSnackbarButton() {
			this.btnTitle === 'dismiss' ? (this.isActive = false) : this.$emit('handle-snackbar');
		},
		clearSnackbarListener() {
			this.isActive = false;
			this.$emit('snackbar-active', this.isActive);
		},
	},
};
</script>

<style lang="scss" scoped>
.md-snackbar.md-theme-default {
	@include font-styles('Futura W01 Medium', 500);
	@include textStyles(16, 23, 0.4);

	border-radius: 4px;
	padding: 6px 6px 6px 16px;
	min-width: 344px;
	background-color: $color-tooltip-grey;
	z-index: 9999;
	.md-snackbar-content {
		span {
			flex: 1;
		}
		button.md-button {
			flex: 0 0 auto;
			text-transform: uppercase;
			color: $color-mid-blue;
			margin-left: 8px;
			font-weight: 700;
		}
	}
}
button.button.text-btn {
}
</style>
